export default class CookieBar {
    constructor(nodeSelector = '.notification--cookie') {
        jQuery('body').on('click', `${nodeSelector}  .notification__toggle`, event => {
            const that = event.currentTarget;
            const thatParent = that.parentNode;
            const date = new Date();
            date.setTime(date.getTime() + (365*24*60*60*1000));
            document.cookie = `DDT_COOKIE=1; expires=${date.toUTCString()}; path=/`;
            thatParent.classList.add('notification--fade-out');
            setTimeout(()=> {
                thatParent.remove();
            }, 250);
        });
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/modules/CookieBar.js